export default __webpack_public_path__ + "static/media/point_right.394062df.svg";